/*
 * @Description: 事业群设置
 * @Author: 杨志航
 * @Date: 2026-09-05 11:25:50
 */
import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Input,
  message,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { allTrim, filterParams } from '@/utils'

const FormItem = Form.Item

const EditGroup = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue } = props.form
  const { setVisible, editData, getList } = props
  const [saveLoading, setSaveLoading] = useState(false)

  useEffect(() => {
    const { name, leaderName } = editData
    setFieldsValue({
      name,
      leaderName,
    })
  }, [])

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const formSubmit = (e) => {
    e.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        const { groupId } = editData
        vals = filterParams(vals)
        vals = {
          id: groupId,
          ...vals,
        }
        setSaveLoading(true)
        api.updateProfitReportGroupName(vals).then(() => {
          setSaveLoading(false)
          setVisible(false)
          message.success('设置成功')
          getList()
        }).catch(() => setSaveLoading(false))
      }
    })
  }

  return (
    <div>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="OA事业群名称">
          {editData.groupName || '--'}
        </FormItem>
        <FormItem label="小程序事业群名称">
          {getFieldDecorator('name')(
            <Input placeholder="请输入小程序事业群名称" />
          )}
        </FormItem>
        <FormItem label="OA事业群负责人">
          {editData.groupLeaderName || '--'}
        </FormItem>
        <FormItem label="小程序事业群负责人">
          {getFieldDecorator('leaderName')(
            <Input placeholder="请输入小程序中显示的负责人姓名" />
          )}
        </FormItem>
        <BtnGroup onCancel={() => setVisible(false)} loading={saveLoading} />
      </Form>
    </div>
  );
}

export default Form.create()(EditGroup)
